import React, { useState, useMemo } from "react";
import { useWallet } from "../../context/walletContext";
import { MdClose } from "react-icons/md";
import { useNotify } from "../../context/NotifyContext";

const LpgServicesForm = ({ bill, onSubmit, operator, close }) => {
  const { notify } = useNotify();
  const { walletAmt } = useWallet();

  const walletBalance = useMemo(
    () => Number(walletAmt?.main?.balance || 0),
    [walletAmt]
  );

  const billAmount = useMemo(
    () => Number(bill?.bill_fetch?.billAmount ?? bill?.amount ?? 0),
    [bill]
  );

  const [amount, setAmount] = useState(billAmount);

  const handlePayClick = () => {
    const finalAmount = Number(amount);

    if (!finalAmount || isNaN(finalAmount) || finalAmount <= 0) {
      notify("Enter a valid amount", "error");
      return;
    }

    if (finalAmount > billAmount) {
      notify(`Amount cannot exceed bill amount ₹${billAmount}`, "error");
      return;
    }

    if (finalAmount > walletBalance) {
      notify(`Amount cannot exceed wallet balance ₹${walletBalance}`, "error");
      return;
    }

    onSubmit({ amount: finalAmount });
  };

  const handleInputChange = (e) => {
    const val = e.target.value;
    if (!/^[0-9]*$/.test(val)) return;

    const num = Number(val);
    const maxAllowed = Math.min(walletBalance, billAmount);

    if (num > maxAllowed) {
      setAmount(maxAllowed);
      return;
    }

    setAmount(val);
  };

  return (
    <div className="ds-card p-3 sm:p-4 w-full">
      <div className="flex items-start justify-between mb-4">
        <h2 className="text-[15px] font-semibold text-[var(--text-dark)]">
          {operator?.name || "LPG Service"}
        </h2>
        <MdClose
          onClick={close}
          className="cursor-pointer text-[var(--text-muted)] hover:text-[var(--error-color)]"
          size={20}
        />
      </div>

      <div className="space-y-3">
        <div className="grid grid-cols-2 border-b border-[var(--border-color)] pb-2 text-[13px]">
          <span className="font-medium text-[var(--text-muted)]">Customer Name:</span>
          <span className="font-semibold text-[var(--text-dark)]">
            {bill?.bill_fetch?.userName || bill?.name || "N/A"}
          </span>
        </div>

        <div className="grid grid-cols-2 border-b border-[var(--border-color)] pb-2 text-[13px]">
          <span className="font-medium text-[var(--text-muted)]">Bill Amount:</span>
          <span className="font-semibold text-[var(--error-color)]">
            ₹ {billAmount}
          </span>
        </div>

        <div className="mt-3">
          <label className="ds-label">
            Booking Amount <span className="text-[var(--error-color)]">*</span>
          </label>
          <input
            type="text"
            value={amount}
            disabled
            onChange={handleInputChange}
            className="ds-input bg-[var(--bg-app)] cursor-not-allowed"
          />
          <button
            type="button"
            onClick={handlePayClick}
            className="ds-btn ds-btn-primary ds-btn-block mt-4"
          >
            Pay Bill
          </button>
        </div>
      </div>
    </div>
  );
};

export default LpgServicesForm;
